exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QuestionMultyView{width:100%;padding:20px;min-height:100vh;display:flex;align-items:center;flex-direction:row;justify-content:space-between}.QuestionMultyView img{max-width:100%}.QuestionMultyView .ant-btn-circle,.QuestionMultyView .block_question{display:flex;align-items:center;justify-content:center}.QuestionMultyView .block_question{flex-direction:column}.QuestionMultyView .help{position:absolute;right:50px;bottom:50px;width:32px;height:32px;border-radius:50%;background-color:#f5f5f5;border:1px solid #d9d9d9;cursor:pointer;display:flex;align-items:center;justify-content:center}.QuestionMultyView .help.active{border-color:#00adff}.ant-btn-primary-circle{border-radius:25px!important}.multyAnswerDesck ul{margin-left:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QuestionMultyView/style.scss
// module id = 5241
// module chunks = 0